import dynamic from 'next/dynamic';

import type { ComponentsAutoplayVideo } from 'queries/graphql';

import { useTextFontOverrides, useHeadingFontOverrides } from 'utils/font-override';
import { buildCssVar } from 'utils/style-override';

import AutoplayVideoItemTheme1 from './components/AutoplayVideoItemTheme1';
import AutoplayVideoItemTheme2 from './components/AutoplayVideoItemTheme2';

import theme1 from './theme1.module.scss';
import theme2 from './theme2.module.scss';

const MarkdownText = dynamic(() => import('generic/MarkdownText'));

export default function AutoplayVideo({
  sectionId,
  tagline,
  heading,
  text,
  items,
  style,
  theme = 'theme2',
}: ComponentsAutoplayVideo & {
  theme?: 'theme1' | 'theme2';
}) {
  const { headingColor, textColor, backgroundColor, headingFont, textFont, itemStyle } =
    style || {};

  const headingFontOverrides = useHeadingFontOverrides(headingFont);
  const textFontOverrides = useTextFontOverrides(textFont);

  const styles = theme === 'theme2' ? theme2 : theme1;
  const AutoplayVideoItem = theme === 'theme2' ? AutoplayVideoItemTheme2 : AutoplayVideoItemTheme1;

  const rootClassNames = ['root', styles.container];
  if (backgroundColor) rootClassNames.push(styles.top_bottom_padding);

  return (
    <div id={sectionId} className={rootClassNames.join(' ')}>
      <style jsx>{`
        .root {
          ${buildCssVar('--heading-color', headingColor, 'var(--heading-color-dark)')}
          ${buildCssVar('--text-color', textColor, 'var(--text-color-dark)')}
          ${buildCssVar('--background-color', backgroundColor, 'var(--default-background-color)')}
          ${headingFontOverrides ?? ''}
          ${textFontOverrides ?? ''}
        }
      `}</style>
      <div className={styles.three_box_section}>
        <div className={styles.process_vd}>
          <div className={styles.sec_wrapper}>
            {tagline && <div className={styles.tagline}>{tagline}</div>}
            {heading && <h1 className={styles.heading}>{heading}</h1>}
            {text && (
              <div className={styles.text}>{text && <MarkdownText text={text}></MarkdownText>}</div>
            )}
            <div className={styles.boxes_container}>
              {items.map(item => (
                <AutoplayVideoItem key={item.id} {...item} itemStyle={itemStyle} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
